"use client";
import React, {MouseEventHandler, ReactNode} from "react";
import CircularProgressIndicator from "@/components/ui/main/CircularProgressIndicator";

export default function MaterialButton({onClick, text, className, loading,
}: {
  text: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  loading?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`transition-all duration-300 bg-stone-950 dark:bg-stone-50 text-white dark:text-black hover:bg-stone-800 dark:hover:bg-stone-300 text-sm font-semibold leading-6 py-1.5 px-4 rounded-lg ${className}`}
    >
      {loading ? <CircularProgressIndicator/> : text}
    </button>
  );
}

export function MaterialButtonCustom({onClick, children, className, loading,
}: {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  loading?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={` ${className}
    transition-all duration-300
    bg-stone-950 dark:bg-stone-50 
    text-white dark:text-black 
    hover:bg-stone-800 dark:hover:bg-stone-300
    text-sm font-semibold leading-6 py-1.5 px-4 rounded-lg`}
    >
      {loading ? <CircularProgressIndicator/> : children}
    </button>
  );
}
